import v43Schema from "../client/schemaVersions/v43.js";
import v44Schema from "../client/schemaVersions/v44.js";
import { createMigration } from "@verdant-web/store";
export default createMigration(v43Schema, v44Schema, async ({ migrate }) => {
    // add or modify migration logic here. you must provide migrations for
    // any collections that have changed field types or added new non-nullable
    // fields without defaults
    // await migrate('collectionName', async (old) => ({ /* new */ }));
});
//# sourceMappingURL=v44.js.map